import { memo, useState } from "react";
import { NavLink } from "react-router-dom";
import MenuItem from "../DropdownMenu/MenuItem";
import "./Submenu.scss";

import { SearchLoad } from "../../FormComponents/SearchLoad/AddSearchLoad";
import { SearchTruck } from "../../FormComponents/SearchSP/SearchTruck";
import FastTagDetails from "../../../Pages/FastTagDetails/FastTagDetails";
import AddFieldMaster from "../../../Pages/FieldsMaster/AddFieldMaster";
import { LicenseRigths } from "../../../Pages/LicenseRights/LicenseRights";
import { UserRights } from "../../../Pages/UserRights/UserRights";
import LinkSaleExpenses from "../../../Pages/SalesBillSetup/LinkSaleExpenses/LinkSaleExpenses";
import BulkNotifications from "../../../Pages/BulkNotifications/BulkNotifications";
import SideNavbar from "../../SideNavbar/SideNavBar";

const Submemu = (props) => {
  const [toggle, setToggle] = useState(false);
  const [routeName, setRouteName] = useState(null);
console.log(props.isDisplayed,props, "props.isDisplayedprops.isDisplayedprops.isDisplayed")
  const handleClick = (route) => {
    if (portalData[route]) {
      setToggle(true);
      setRouteName(route);
    }
  };

  const DynamicComponent = routeName ? portalData[routeName] : null;
  return toggle && DynamicComponent ? (
    <DynamicComponent show={toggle} ParentPortalCloseFunction={() => setToggle(false)} />
  ) : (
    <div className={`submenu ${props.isDisplayed ? "" : ""}`}>
      {props.content &&
        props.content.map((e, i) => {
          return (
            <div key={i}>
              {e.Page_Access ? (
                portalData[e.Route] ? (
                  <div className="menuitem" onClick={() => handleClick(e.Route)}>
                    {e.Page_Name}
                  </div>
                ) : (
                  <NavLink className="navLinks" to={e.Route === "/ledger/" ? "/ledger" : `/${e.Route}`}>
                    <MenuItem text={e.Page_Name} />
                  </NavLink>
                )
              ) : null}
            </div>
          );
        })}
    </div>
  );
};

export default memo(Submemu);

const portalData = {

  SearchLoad: SearchLoad,
  SearchTruck: SearchTruck,
  FastTagDetails,
  TableFieldMaster: AddFieldMaster,
  LicenseeRights: LicenseRigths,
  UserPageRights: UserRights,
  LinkSaleExpense: LinkSaleExpenses,
  SideNavbar: SideNavbar,
  QuickLinks: SideNavbar,
  BulkNotification: BulkNotifications,
};
